import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import RefreshDialog from './RefreshDialog';

const mapStateToProps = (/* , props */) => ({});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RefreshDialog));
